import React from 'react';
type QrPatternProps = {
  className?: string;
};
const SIZE = 21;
const FINDERS: Array<[number, number]> = [[0, 0], [14, 0], [0, 14]];
const cells = Array.from({
  length: SIZE * SIZE
}, (_, i) => isCellOn(i % SIZE, Math.floor(i / SIZE)));

/** A decorative, non-scannable QR-style pattern used only as an example. */
export function QrPattern({
  className = ''
}: QrPatternProps) {
  return <div className={`grid ${className}`} style={{
    gridTemplateColumns: `repeat(${SIZE}, 1fr)`
  }} aria-hidden="true" data-id="element-153" data-mp="337pydyyapmb1">
      {cells.map((on, i) => <span key={i} className={`aspect-square ${on ? 'bg-mm-black' : ''}`} data-id="element-154" data-mp="2u6rstc87l6qc" data-mpi={i} />)}
    </div>;
}
function isCellOn(x: number, y: number): boolean {
  for (const [ox, oy] of FINDERS) {
    if (x >= ox - 1 && x <= ox + 7 && y >= oy - 1 && y <= oy + 7) {
      const dx = x - ox;
      const dy = y - oy;
      if (dx < 0 || dy < 0 || dx > 6 || dy > 6) return false;
      if (dx === 0 || dy === 0 || dx === 6 || dy === 6) return true;
      return dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4;
    }
  }
  return (x * 13 + y * 7 + x * y * 3) % 5 < 2;
}